<template>
  <div class="content">
    <el-tabs class="tabLv3 taskContent" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 考试管理
        </span>
        <div class="w_normalNav" :parent="self">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="GreenSmBtn" @click="$refs.taskDialog.toAddNew()">新增</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="考试名称:">
                <el-input v-model="seefrom.name" placeholder="请输入考试名称"></el-input>
              </el-form-item>
              <!-- <el-form-item label="应试部门">
                <el-input placeholder="请选择应试部门" readonly v-model="seefrom.deptName" @focus="selectDept"></el-input>
              </el-form-item> -->
              <el-form-item label="考试状态:">
                <el-select :popper-append-to-body="false" v-model="seefrom.examStatus" placeholder="请选择考试状态" style="width:100%">
                  <el-option v-for="(item,index) in examStatusArr" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <div class="tableWrapper">
          <el-table :data="tableData" v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" style="width: 100%" class="stripeTable" height="500" ref="Table">
            <el-table-column show-overflow-tooltip :label="label" :prop="prop" :align="align" :width="width" v-for="({prop,label,align, width}) in config" :key="prop.toString()"></el-table-column>
            <el-table-column label='状态' prop="testPaperId" :formatter="statusSymbol"></el-table-column>
            <el-table-column label="操作" width="300" align="left">
              <template slot-scope="scope">
                <el-link icon="iconfont iconcheck1" type="text" size="small" v-if="scope.row.status == 0" @click="operation(scope.$index,scope.row)">开启</el-link>
                <el-link icon="iconfont icontingyong" type="text" size="small" v-if="scope.row.status == 1" @click="operation(scope.$index,scope.row)">关闭</el-link>
                <el-link icon="iconfont iconedit" type="text" size="small" @click="$refs.taskDialog.edit(scope.$index,scope.row)" :disabled='scope.row.status == 1'>编辑</el-link>
                <!-- <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index,scope.row)" :disabled='scope.row.status == 1'>删除</el-link> -->
                <el-link icon="iconfont iconcheck" type="text" size="small" @click="checkResult(scope.row)">查看结果统计</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer">
            <el-pagination layout="prev, pager, next" :page-size="10" @current-change="handleCurrentChange" :current-page="currentPage" :total="nTotal">
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <task-dialog ref="taskDialog" :testArr="testArr"></task-dialog>
    <result-summary ref="resultSummary"></result-summary>
    <company-dialog ref="companyDialg" @confirm="confirmSelect" status="search"></company-dialog>
  </div>
</template>

<script>
import { dt, obj2urlsp } from 'utils'
import resultSummary from './resultSummary'
export default {
  name: 'testManage',
  data() {
    return {
      key: '',
      title: '',
      tabName: 'jsgl',
      testArr: [],
      departArr: [],
      form_jsgl: {},
      items: [],
      seefrom: {},
      tableLoading: false,
      tableData: [],
      nTotal: 0,
      currentPage: 1,
      currentSize: 10,
      examStatusArr: [
        {
          label: '未开始',
          value: 0
        },
        {
          label: '进行中',
          value: 1
        },
        {
          label: '已结束',
          value: -1
        }
      ]
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'name',
          label: '考试名称'
        },
        {
          prop: 'paperName',
          label: '试卷名称'
        },
        {
          prop: 'startTime',
          label: '开始时间'
        },
        {
          prop: 'endTime',
          label: '结束时间'
        },
        {
          prop: 'deptName',
          label: '应试部门'
        },
        {
          prop: 'duration',
          label: '考试时长(min)'
        },
        {
          prop: 'examStatusName',
          label: '考试状态'
        }
      ]
    },
    dt() {
      return dt.map(({ label }) => label)
    }
  },
  components: {
    normalNav: () => import('public/normalNav'),
    taskDialog: () => import('./taskDialog'),
    easyTable: () => import('public/easyTable'),
    searchForm: () => import('public/searchForm'),
    companyDialog: () => import('./companyDialog'),
    resultSummary
  },
  mounted() {
    this.getTest()
    this.getTableData()
  },
  methods: {
    statusSymbol(row, column) {
      return row.status == 0 ? '已关闭' : '已开启'
    },
    //搜索
    subSeefrom() {
      this.currentPage = 1
      this.getTableData()
    },
    //重置
    reset() {
      this.seefrom = {}
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getTableData()
    },
    getTableData() {
      this.tableLoading = true
      this.$axiosget('operation/exam/getPage', {
        params: {
          pageSize: this.currentSize,
          pageNum: this.currentPage,
          ...this.seefrom
        }
      }).then((res) => {
        this.tableLoading = false
        this.tableData = res.data.data.list
        this.nTotal = res.data.data.total
      })
    },
    getTest() {
      this.$axiosget('operation/examPaper/publishList').then((res) => {
        this.testArr = res.data.data
      })
    },
    selectDept() {
      let obj = {}
      if (this.seefrom.deptId) {
        obj.id = this.seefrom.deptId
        obj.label = this.seefrom.deptName
        this.$refs.companyDialg.look(obj)
      } else {
        this.$refs.companyDialg.look(obj)
      }
    },
    confirmSelect(id, name) {
      this.$set(this.seefrom, 'deptId', id)
      this.$set(this.seefrom, 'deptName', name)
    },
    // 操作
    operation(index, row) {
      let mag, status
      if (row.status == 0) {
        mag = '开启'
        status = 1
      } else {
        mag = '关闭'
        status = 0
      }

      this.$confirm(mag + '该考试?', '操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axiosput('operation/exam/status', {
          id: row.id,
          status: status
        }).then((res) => {
          if (res.data.status === '10000') {
            this.getTableData()
            this.$message({
              type: 'success',
              message: `${mag}成功！`
            })
          }
        })
      })
    },
    //删除
    deleteMsg(index, row) {
      this.$confirm('删除该条数据?', '删除操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axiosdelete('operation/exam', {
          params: {
            id: row.id
          }
        }).then((res) => {
          if (res.data.status == '10000') {
            this.getTableData()
            this.$message.success('删除成功!')
          }
        })
      })
    },
    // 查看结果统计
    checkResult(row) {
      this.$refs.resultSummary.checkDetail(row.id)
    }
  }
}
</script>
<style lang="less">
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
</style>

<style scoped lang="less">
.OrangeSmBtn {
  background: #21b8a1;
}
// .normalNav {
//   padding-top: 10px;
// }

/deep/ .el-pagination {
  .el-pagination__total {
    color: #b5b5b5;
  }

  .el-pagination__jump {
    color: #b5b5b5;
  }

  .el-select .el-input .el-input__inner,
  .el-pagination__jump .el-input .el-input__inner {
    background-color: #2e3657;
    border-color: rgba(221, 221, 221, 0.2);
    color: #f5f5f5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/exam/taskManage/index.vue